/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { Stream } from '../stream.schema';

export const TransmittalDocumentFileContentDto = zod.object({
  "content": zod.lazy(() => Stream).optional(),
  "fileName": zod.string().optional(),
  "fileTypeId": zod.number().optional(),
  "fileTypeCode": zod.string().optional(),
  "contentType": zod.string().optional()
});

export type TransmittalDocumentFileContentDto = zod.input<typeof TransmittalDocumentFileContentDto>;
export type TransmittalDocumentFileContentDtoOutput = zod.output<typeof TransmittalDocumentFileContentDto>;
